import { waLink, WA_MESSAGES } from "@/lib/site";
import { MessageCircle } from "lucide-react";

export const WhatsAppFab = () => (
    <a
        data-testid="floating-whatsapp-btn"
        href={waLink(WA_MESSAGES.general)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Cherry Blossom Gifts on WhatsApp"
        className="fab-pulse fixed bottom-5 right-5 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform duration-200"
    >
        <MessageCircle size={26} strokeWidth={2.2} />
    </a>
);

export default WhatsAppFab;
